import "@/App.css";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LoveStory from "./components/LoveStory";
import Timeline from "./components/Timeline";
import Location from "./components/Location";
import Gallery from "./components/Gallery";
import RSVP from "./components/RSVP";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import AdminDashboard from "./pages/AdminDashboard";
import AdminContent from "./pages/AdminContent";
import AdminGallery from "./pages/AdminGallery";
import AdminSeating from "./pages/AdminSeating";
import AdminMusic from "./pages/AdminMusic";
import DJDashboard from "./pages/DJDashboard";
import { Impressum, Datenschutz, AGB } from "./pages/LegalPages";
import { ContentProvider } from "./context/ContentContext";
import Seating from "./components/Seating";
import Wishes from "./components/Wishes";

function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <LoveStory />
        <Timeline />
        <Location />
        <Gallery />
        <Seating />
        <Wishes />
        <RSVP />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    document.title = "Nicole & Nico · 01.08.2026";
  }, []);

  return (
    <div className="App bg-background text-foreground">
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{ style: { fontFamily: "Manrope, sans-serif" } }}
      />
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/gallery" element={<AdminGallery />} />
            <Route path="/admin/seating" element={<AdminSeating />} />
            <Route path="/admin/music" element={<AdminMusic />} />
            <Route path="/dj" element={<DJDashboard />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
